export default {
  dataIterator: {
    rowsPerPageText: 'Số mục mỗi trang:',
    rowsPerPageAll: 'Tất cả',
    pageText: '{0}-{1} trong tổng {2}',
    noResultsText: 'Không tìm thấy bản ghi phù hợp',
    nextPage: 'Trang sau',
    prevPage: 'Trang trước'
  },
  dataTable: {
    rowsPerPageText: 'Số hàng mỗi trang:'
  },
  noDataText: 'Không có dữ liệu',
  carousel: {
    prev: 'Hình ảnh trước',
    next: 'Hình ảnh tiếp theo'
  },
  errors: {
    codeIncorrect: 'Mã không đúng.',
    errorLogin: 'Lỗi đăng nhập',
    qr: {
      notAllowed: 'LỖI: bạn cần cấp quyền truy cập camera',
      notFound: 'LỖI: thiết bị này không có camera',
      notSupported: 'LỖI: cần môi trường bảo mật (HTTPS hoặc localhost)',
      notReadable: 'LỖI: camera có đang bị dùng bởi ứng dụng khác?',
      overConstrained: 'LỖI: camera được cài đặt không phù hợp',
      streamAPINotSupported: 'LỖI: Stream API không được hỗ trợ trong trình duyệt này',
      scanFailed: 'Mã QR không hợp lệ',
      tableNumberFailed: 'Số bàn không hợp lệ'
    },
    location: {
      inStoreTitle: 'Vị trí hiện tại của bạn không trong cửa hàng',
      inStoreDescription: 'Bạn không thể đặt món tại chỗ, vui lòng chọn Mang đi hoặc Giao hàng',
      inStoreBtn: 'Chấp nhận',
      locationDisabledTitle: 'Vui lòng cho phép truy cập GPS',
      locationDescription: 'Vui lòng quét lại mã QR, cho phép vị trí GPS, hoặc bật từ cài đặt điện thoại',
      locationBtn: 'Chấp nhận'
    },
    cart: {
      menuUnavailable: 'Thực đơn không khả dụng trong khung giờ này',
      startShopping: 'Bắt đầu đặt hàng'
    },
    schedule: {
      availableTimes: '{0} chỉ có từ {1} - {2}',
      unavailableTimes: '{0} không có từ {1} - {2}',
      availableDay: '{0} sẽ có vào {1} lúc {2}',
      unavailable: '{0} hiện không khả dụng. Hãy thử loại đơn hàng khác',
      startScheduling: 'Bạn có thể bắt đầu lên lịch đặt hàng từ {0} lúc {1}'
    },
    paymentUnsuccessful: 'Thanh toán thất bại',
    temporarilyAppear: 'Khoản này có thể tạm thời xuất hiện trên hóa đơn trước khi được loại bỏ',
    pageNotFound: 'Không tìm thấy trang',
    storeNotFoundMessage: 'Cửa hàng bạn tìm không thể được tìm thấy. Có thể đã bị di dời, xoá, hoặc URL sai.'
  },
  common: {
    storeHoursClosedHoliday: "Đóng cửa",
    today: 'Hôm nay',
    nextAvailable: 'Tiếp theo khả dụng',
    referralButtonText: 'Mời bạn bè',
    pointsEarned: 'Điểm đã nhận',
    confirmTitle: 'Vui lòng xác nhận',
    confirmDesc: 'Bạn có chắc muốn chuyển khỏi chọn ăn tại chỗ?',
    actionText: 'Đồng ý, chuyển',
    pickup: 'Mang đi',
    delivery: 'Giao hàng',
    availableToDeliver: 'Có thể giao hàng',
    notAvailableForDelivery: 'Không giao hàng được',
    loginDescription: 'Đăng ký hoặc đăng nhập ngay để nhận mã giảm giá độc quyền, phần thưởng, và ưu đãi cá nhân!',
    orderNow: 'Đặt ngay',
    hours: 'Giờ',
    location: 'Địa điểm',
    contact: 'Liên hệ',
    socials: 'Mạng xã hội',
    snappyWhy: 'Vì sao chọn Snappy',
    snappyBlog: 'Blog',
    snappyPricing: 'Bảng giá',
    snappyDemo: 'Đặt lịch demo',
    snappyCaseStudies: 'Câu chuyện khách hàng',
    clickToRedeem: 'Nhấn để đổi',
    apply: 'Áp dụng',
    order: 'Đặt',
    sortByDistance: 'Sắp xếp theo khoảng cách',
    sortByAlpha: 'Sắp xếp theo chữ cái',
    searchLocations: 'Tìm kiếm địa điểm',
    az: 'A-Z',
    nearest: 'Gần nhất',
    atLeast: 'Tối thiểu',
    to: 'đến',
    takeout: 'Mang đi',
    or: 'hoặc',
    guest: 'Khách',
    back: 'Quay lại',
    other: 'Khác',
    groups: 'Nhóm',
    options: 'Tùy chọn',
    edit: 'Chỉnh sửa',
    register: 'Đăng ký',
    poweredBy: 'ĐƯỢC CUNG CẤP BỞI',
    firstName: 'Tên',
    lastName: 'Họ',
    phone: 'Điện thoại',
    phoneNumber: 'Số điện thoại',
    address: 'Địa chỉ',
    storeHours: 'Giờ mở cửa',
    onlineOrderAvailableUntil: 'Đặt hàng trực tuyến đến',
    mobileNumber: 'Số di động',
    status: 'Trạng thái',
    points: 'Điểm',
    balance: 'Số dư',
    save: 'Lưu',
    changesSaved: 'Thay đổi đã được lưu',
    cancel: 'Huỷ',
    confirm: 'Xác nhận',
    message: 'Tin nhắn',
    loadMore: 'Tải thêm',
    loading: 'Đang tải...',
    expires: 'Hết hạn',
    login: 'Đăng nhập / Đăng ký',
    tweet: 'Tweet',
    share: 'Chia sẻ',
    resend: '(Gửi lại trong: {0})',
    newCode: 'Mã mới',
    logout: 'Đăng xuất',
    fillFields: 'Vui lòng điền tất cả các trường bắt buộc',
    invalidEmail: 'Email không hợp lệ',
    verify: 'Mã có 6 chữ số',
    continue: 'Tiếp tục',
    verifyCode: 'Xác nhận mã',
    sixDigitCode: 'Mã 6 chữ số',
    unlimited: 'Không giới hạn',
    upTo: 'tối đa',
    selected: 'đã chọn',
    items: 'mục',
    amount: 'Số tiền',
    scanQRCode: 'Quét mã QR cho ăn tại chỗ',
    loadingQRScanner: 'Đang tải bộ quét...',
    reloadQRScanner: 'Tải lại',
    open: 'Mở',
    open2: 'Mở',
    closed: 'Đóng',
    closed2: 'Đóng',
    email: 'E-Mail',
    select: 'Chọn',
    ok: 'Xác nhận',
    okConfirm: "Ok",
    off: 'TẮT',
    app: {
      text1: 'Mở trong',
      text2: 'ứng dụng',
      btn: 'Mở'
    },
    captcha: {
      main: 'Trang này được bảo vệ bởi reCAPTCHA và',
      privacy: 'Chính sách riêng tư',
      and: 'và',
      terms: 'Điều khoản dịch vụ',
      apply: 'áp dụng.'
    },
    disclaimer: {
      main: 'Bằng cách đăng nhập, tôi đồng ý với <link-tos>Điều khoản dịch vụ</link-tos> & <link-pp>Chính sách bảo mật</link-pp>. Tôi đồng ý nhận tin nhắn SMS và các thông tin liên lạc kỹ thuật số khác, bao gồm phiếu giảm giá, ưu đãi đặc biệt và khuyến mãi từ {businessName}. Có thể áp dụng phí tin nhắn và dữ liệu tiêu chuẩn.',
      register: 'Bằng cách nhấn ĐĂNG KÝ bạn đồng ý với <link-tos>Điều khoản dịch vụ</link-tos> & <link-pp>Chính sách riêng tư</link-pp> của Snappy. Snappy sẽ sử dụng thông tin SMS để bảo mật tài khoản và gửi thông báo. Bạn có thể từ chối nhận tin nhắn SMS bất cứ lúc nào.'
    },
    addedToCart: 'Đã thêm "{0}" vào giỏ hàng',
    yourOrderId: 'Mã đơn hàng của bạn là'
  },
  hours: {
    twentyFourHours: 'Mở 24 giờ',
    midNight: 'Nửa đêm',
    mon: "Thứ 2",
    tues: "Thứ 3",
    wed: "Thứ 4",
    thurs: "Thứ 5",
    fri: "Thứ 6",
    sat: "Thứ 7",
    sun: "Chủ nhật",
    monday: "Thứ 2",
    tuesday: "Thứ 3",
    wednesday: "Thứ 4",
    thursday: "Thứ 5",
    friday: "Thứ 6",
    saturday: "Thứ 7",
    sunday: "Chủ nhật"
  },
  menu: {
    specialRequests: 'Yêu cầu đặc biệt',
    required: 'BẮT BUỘC',
    optional: 'TUỲ CHỌN',
    soldOut: 'Hết hàng',
    selectMenu: 'Vui lòng chọn thực đơn',
    menuTitle: 'Thực đơn',
    promotionsAndRewards: 'Khuyến mãi và phần thưởng',
    categories: 'Danh mục',
    noMenu:  'Không tìm thấy thực đơn trong cửa hàng',
    dropdown: 'Thực Đơn Thả Xuống',
    unavailable: 'Thực đơn không khả dụng',
    available: 'Có sẵn',
    dayAvailable: 'Tiếp theo có sẵn',
    availableOffHours: 'Thực đơn này có trong đặt hàng theo lịch',
    menuIsExclusive: 'Các mục từ thực đơn khác nhau không thể được thêm vào cùng một giỏ hàng',
    item: {
      onlyAvailable: 'Có sẵn',
      available: 'Món này chỉ có từ {0} - {1}',
      prepTime: 'Món này thường mất khoảng {0} để chuẩn bị'
    },
    menuAvailability: 'Thời gian có thực đơn',
    gotIt: 'Hiểu rồi!',
    onlyAvailable: 'Thực đơn này chỉ khả dụng trong giờ cụ thể:',
    pricingBanner: 'Đặt hàng trực tiếp từ {2} và tiết kiệm trung bình tới {0}% so với {1}'
  },
  cart: {
    title: 'Giỏ hàng',
    startShopping: 'Bắt đầu đặt hàng',
    continue: 'Tiếp tục',
    serviceFee: 'Phí dịch vụ',
    takeOutOrder: 'ĐƠN MANG ĐI',
    backToLogin: 'Quay về đăng nhập',
    enterYourAddress: 'Địa chỉ giao hàng',
    startAdding: 'Bắt đầu thêm món vào giỏ hàng để tạo đơn',
    buildOrder: "Thêm món mới để tiếp tục tạo đơn",
    currentlyClosed: ' hiện đang đóng cửa. Vui lòng trở lại trong giờ phù hợp.',
    delivery: 'Giao hàng',
    pickup: 'Mang đi',
    dinein: 'Ăn tại chỗ',
    estTimeHours: 'giờ',
    estTimeMins: 'phút',
    subtotal: 'Tạm tính',
    deliveryFee: 'Phí giao hàng',
    tbd: 'Chưa xác định',
    deliveryMinimum: 'Tối thiểu cho giao hàng',
    pickupMinimum: 'Tối thiểu cho lấy hàng',
    tax: 'Thuế',
    tip: 'Tiền boa',
    tipDriver: 'Cho người giao hàng',
    tipStore: 'Ủng hộ cửa hàng bằng tiền boa',
    rewards: 'Phần thưởng',
    total: 'Tổng cộng',
    btnCheckout: 'Thanh toán',
    addToCart: 'Thêm vào giỏ',
    aiRecommendationsTitle: 'Đề xuất cho bạn',
    aiRecommendationsTitleGuest: 'Đề xuất',
    aiRecommendationsSubtitle: 'Dựa trên đơn hàng của bạn',
    aiRecommendationsSubtitleGuest: 'Phổ biến tại cửa hàng này',
    aiRecommendationsFrom: 'Từ',
    saveCartItem: 'Cập nhật giỏ hàng',
    clickToSee: 'Nhấn để xem tùy chọn',
    payWithMembership: 'Thanh toán bằng thành viên',
    btnSubmitSubOrder: 'Gửi đơn hàng',
    processing: 'Đang xử lý đơn hàng của bạn',
    pastOrders: 'Đơn hàng trước',
    discount: 'Giảm giá',
    btnPayOrder: 'Gửi đơn hàng',
    closeModal: 'Đóng',
    cartUnavailable: 'Có mục trong giỏ không thể đặt vì không phù hợp hoặc không khả dụng',
    storeUnavailable: 'Hiện không khả dụng',
    storeClosedBtn: 'Cửa hàng đã đóng',
    offHourOrderingMaybeAllowed: 'Cửa hàng hiện đóng. Tuy nhiên, bạn vẫn có thể đặt lịch cho thời gian sau.',
    advanceBookingWindow: 'Cửa hàng đang mở nhưng chưa nhận đơn hàng. Bạn có thể đặt lịch cho thời gian sau.',
    deliveryUnavailable: 'Giao hàng hiện không khả dụng',
    pickupUnavailable: 'Lấy hàng hiện không khả dụng',
    tooSmallForDelivery: 'Số tiền đơn hàng quá nhỏ để giao hàng (Tối thiểu: {0})',
    tooSmallForPickup: 'Số tiền đơn hàng quá nhỏ để lấy hàng (Tối thiểu: {0})',
    invalidCoupon: 'Mã giảm giá không hợp lệ',
    cartErrors: 'Lỗi giỏ hàng',
    removeInvalidItemToContinue: 'Vui lòng xóa để tiếp tục.',
    discountNotUsed: 'Giỏ hàng không được để trống',
    deliveryDisabled: 'Giao hàng tạm thời bị vô hiệu bởi cửa hàng',
    pickupDisabled: 'Lấy hàng tạm thời bị vô hiệu bởi cửa hàng',
    deliveryDisabledUntil: 'Giao hàng tạm thời bị vô hiệu bởi<br>cửa hàng cho đến {0}',
    pickupDisabledUntil: 'Lấy hàng tạm thời bị vô hiệu bởi<br>cửa hàng cho đến {0}',
    asapClosed: 'Đã đóng cửa · Mở lại {0} lúc {1}',
    asapPastCutoff: 'Không còn nhận đơn hàng cho hôm nay',
    asapSuspendedToday: 'Không còn nhận đơn hàng cho hôm nay',
    storeStoppedAcceptingOrders: 'Cửa hàng đã ngừng nhận đơn trong khi bạn đang thanh toán. Hãy chọn một thời gian đặt lịch để tiếp tục.'
  },
  account: {
    accountInfo: 'Thông tin tài khoản',
    orderHistory: 'Lịch sử đơn hàng',
    paymentMethods: 'Phương thức thanh toán',
    contactInfo: 'Thông tin liên hệ',
    membershipInfo: 'Thông tin thành viên',
    member: 'Thành viên',
    nonMember: 'Không phải thành viên',
    creditCard: 'Thẻ tín dụng',
    nameOnCard: 'Tên trên thẻ',
    cardNumber: 'Số thẻ',
    expires: 'Hết hạn',
    cvc: 'CVC',
    mmyy: 'MM / YY',
    country: 'Quốc gia thanh toán',
    saveCard: 'Lưu thẻ',
    addPaymentMethod: 'Thêm phương thức thanh toán',
    deliveryDetails: 'Chi tiết giao hàng',
    noOrderHistory: 'Không có lịch sử đơn hàng',
    noPaymentMethods: 'Không có phương thức thanh toán',
    addPaymentMethodPrompt: 'Vui lòng thêm phương thức thanh toán',
    noCreditCards: 'Không có thẻ tín dụng',
    otherPostalCode: 'Đối với thẻ ngoài Mỹ hoặc Canada, vui lòng nhập bất kỳ số nào',
    membership: 'Thành viên',
    history: 'Lịch sử',
    payments: 'Thanh toán',
    offline: 'Thanh toán tại cửa hàng',
    orderId: 'Mã đơn hàng',
    editTitle: 'Chỉnh sửa thông tin cá nhân',
    payment: {
      title: 'Xóa phương thức thanh toán',
      body: 'Bạn có chắc muốn xóa phương thức thanh toán này?',
      cancel: 'Huỷ',
      delete: 'Xoá',
      status: {
        cvcFailed: 'CVC không hợp lệ',
        postalCodeFailed: 'Mã bưu điện không đúng',
        expiredCard: 'Thẻ đã hết hạn'
      }
    },
    rewards: {
      redeemFor: 'Đổi lấy',
      rewardOptions: 'Tùy chọn phần thưởng',
      coupons: 'Phiếu giảm giá',
      punchCards: 'Thẻ tích điểm',
      using: 'Đang sử dụng',
      remaining: 'Còn lại',
      free: 'Miễn phí',
      purchases: 'Lượt mua',
      redeem: 'Đổi',
      max: 'Tối đa',
      points: 'Điểm',
      credits: 'Số dư tín dụng',
      discount: 'Giảm giá',
      yourPoints: 'Điểm của bạn',
      creditsEarned: '{0} đã nhận',
      worth: 'Giá trị',
      insufficientFunds: 'Không đủ điểm',
      removeFirst: 'Vui lòng xóa tùy chọn phần thưởng đang hoạt động trước',
      punchCardRibbon: 'Mua thêm {0} {1} để nhận {2}!',
      selectItem: 'Chọn món',
      availableInCart: 'Phần thưởng có sẵn được hiển thị trong giỏ hàng',
      availableInCartUpdated: 'Nhấn vào giỏ hàng để đổi phần thưởng này!',
      alreadyInCart: '"{0}" đã có trong giỏ hàng bạn',
      missingPoints: 'Bạn cần thêm {0} điểm để sử dụng thẻ tích điểm này!',
      inEligible: 'Bạn không đủ điều kiện cho mã giảm giá này',
      noExpiration: 'Không có hạn sử dụng',
      noLimitation: 'Không có giới hạn',
      buy1Get1Free: 'MUA 1 TẶNG 1',
      buy1Get1PercentOff: 'MUA 1 GIẢM {0}% CHO CÁI THỨ 2',
      buy1Get1AmountOff: 'MUA 1 GIẢM ${0} CHO CÁI THỨ 2',
      validForSelectItems: 'Áp dụng cho các mặt hàng được chọn',
      discountPercentOff: 'Giảm {0}%',
      discountAmountOff: 'Giảm {0}{1}',
      discountOff: 'Giảm {0}',
      discountUpTo: '{0}, tối đa {1}',
      maxDiscountReached: 'Đã đạt mức giảm giá tối đa {0}',
      maxDiscountOf: 'Tối đa {0}',
      maxDiscountOfDetail: 'Giảm giá tối đa {0}',
      offerExpires: 'Ưu đãi hết hạn: {0}',
      loginPrompt: 'Vui lòng đăng nhập để xem phần thưởng',
      inPersonRedeemable: 'Phần thưởng này chỉ đổi được tại cửa hàng',
      orderRewards: {
        congrats: 'Chúc mừng!',
        coupons: 'Đơn hàng của bạn đã được thưởng một mã giảm giá',
        lossFallback: 'Rất tiếc bạn chưa được thưởng lần này, hãy thử lại đơn hàng tiếp theo!'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'Đề xuất cho bạn',
    aiRecommendationsCategoryGuest: 'Đề xuất',
    deliveryProvider: {
      robot: 'Robot',
      human: 'Shipper',
      byRobot: 'Gặp robot bên ngoài',
      byHuman: 'Gặp nhân viên giao hàng tại cửa',
      recommended: 'Được cửa hàng đề xuất',
      notSupported: '{0} không hỗ trợ giao đến địa chỉ của bạn', // {0} là Robot hoặc Shipper
      deliveryInstructions: 'Vui lòng lưu ý, Robot không leo cầu thang. Bạn sẽ cần mã được gửi qua email để lấy món'
    },
    error: {
      empty: 'Không có gì để hiển thị!',
      noResults: 'không trả về kết quả nào.',
      tryAdjusting: 'Hãy thử thay đổi bộ lọc',
      clear: 'Xoá tìm kiếm'
    }
  },
  order: {
    estimatedTime: 'Đơn hàng của bạn đã được đặt thành công, sẽ sẵn sàng để lấy vào {0}',
    estimatedTimeDiff: 'Đơn hàng của bạn đã được đặt thành công, sẽ sẵn sàng trong khoảng {0}',
    successfulOrder: 'Đơn hàng đã đặt thành công',
    deliveryAddressInvalid: 'Địa chỉ bạn nhập không hợp lệ, vui lòng thử lại',
    deliveryAddressMustBeSet: 'Bạn phải đặt địa chỉ giao hàng',
    deliveryAddressMustBeInRange: 'Xin lỗi, địa chỉ của bạn không trong phạm vi giao hàng, vui lòng liên hệ cửa hàng để đặt',
    noPaymentMethodSelected: 'Vui lòng chọn phương thức thanh toán',
    insufficientPoints: 'Không đủ điểm thành viên',
    requiresAdditionalMethod: 'Không đủ số dư, cần phương thức thanh toán thứ hai',
    cardMinimumCharge: 'Phải thanh toán ít nhất {0} bằng thẻ. Hãy thêm tiền boa hoặc món khác, hoặc thanh toán đơn này bằng thẻ.',
    minCardChargeNote: 'Phí thanh toán thẻ tối thiểu {0}',
    applyMembershipInstead: 'Áp dụng {0} thay thế',
    noPaymentMethods: 'Vui lòng chọn phương thức thanh toán',
    pickUpDetails: 'Chi tiết lấy hàng',
    orderDetails: 'Chi tiết đơn hàng',
    selectOrderType: 'Chọn loại đơn hàng',
    orderPlaced: 'Đơn hàng đã được đặt',
    orderScheduled: 'Thời gian đặt trước',
    orderNotes: 'Ghi chú đơn hàng',
    pickUpTime: 'Thời gian lấy hàng',
    pickUpDay: 'Ngày lấy hàng',
    deliveryTime: 'Thời gian giao hàng',
    deliveryDay: 'Ngày giao hàng',
    deliveryAddress: 'Địa chỉ giao hàng',
    addressLine1: 'Địa chỉ dòng 1',
    addressLine2: 'Địa chỉ dòng 2',
    postalCode: 'Mã bưu điện',
    city: 'Thành phố',
    payment: 'Thanh toán',
    placeOrder: 'Đặt đơn',
    personalDetails: 'Thông tin cá nhân',
    tableNumberSet: 'Bàn của bạn đã được thiết lập.',
    onlyOffline: "Cửa hàng này chỉ nhận thanh toán tại chỗ.",
    paidOffline: "Thanh toán sẽ được thực hiện tại cửa hàng",
    emailReceipt: "Gửi hóa đơn qua email cho tôi",
    offlineEmailReceipt: "Gửi xác nhận đơn hàng qua email",
    status: {
      new: 'Mới',
      inProgress: 'Đang xử lý',
      ready: 'Sẵn sàng',
      cancelled: 'Đã huỷ',
      refunded: 'Đã hoàn tiền',
      completed: 'Hoàn tất'
    },
    orderActions: {
      call: 'Gọi',
      direction: 'Chỉ đường',
      orders: 'Xem đơn hàng',
      feedbackTitle: 'Hãy cho phản hồi đơn hàng của bạn',
      feedbackLabel: 'Gửi phản hồi'
    }
  },
  iosBanner: {
    partOne: 'Nhấn vào biểu tượng chia sẻ',
    partTwo: 'và sau đó chọn “Thêm vào màn hình chính”',
    partThree: 'để cài đặt ứng dụng'
  },
  checkoutSuccess: {
    text: 'Thanh toán thành công'
  },
  orderSubmitted: {
    text: 'Đơn hàng đã được gửi'
  },
  deliveryDialog: {
    title: 'Chi tiết giao hàng',
    deliverAsap: 'Giao càng sớm càng tốt',
    schedule: 'Lên lịch',
    update: 'Cập nhật',
    selectAddress: 'Vui lòng nhập địa chỉ',
    noDeliveryProviders: 'Không có nhà cung cấp giao hàng hỗ trợ địa chỉ đó',
    deliveryAddressSet: 'Đã đặt địa chỉ giao hàng!',
    selectDateTime: 'Vui lòng chọn ngày và giờ hợp lệ',
    notAvailable: 'Xin lỗi, không khả dụng',
    pleaseSelectDate: 'Vui lòng chọn ngày'
  },
  orderDialog: {
    title: 'Chi tiết lấy hàng',
    deliveryTitle: 'Chi tiết giao hàng',
    pickUpAsap: 'Lấy ngay',
    deliverAsap: 'Giao ngay',
    schedule: 'Lên lịch',
    done: 'Xong',
    selectDate: 'Vui lòng chọn ngày',
    notAvailable: 'Xin lỗi, không khả dụng',
    selectDateTime: 'Vui lòng chọn ngày và giờ hợp lệ',
    noAvailableDays: "Xin lỗi, hiện không có ngày nào khả dụng",
    earliestDate: "Ngày sớm nhất đã được đặt",
    staleTimeBodyGroup: "Cửa hàng không thể chuẩn bị đơn hàng của bạn trước {0}. Chọn thời gian mới để tiếp tục — các món của nhóm và khách sẽ không thay đổi.",
    staleTimeBodySolo: "Cửa hàng không thể chuẩn bị đơn hàng của bạn trước {0}. Chọn thời gian mới để tiếp tục.",
    confirmSlot: "Xác nhận {0}",
    goBack: "Quay lại"
  },
  storeLocation: {
    pickUpAt: 'Nhận tại',
    inStore: 'Trong cửa hàng',
    pickUpTime: 'Thời gian nhận',
    deliveryTime: 'Thời gian giao',
    time: 'Thời gian',
    deliverTo: 'Giao tới',
    clickToSet: 'Nhấn để thiết lập'
  },
  orderTypes: {
    pickup: 'Mang đi',
    delivery: 'Giao hàng',
    dineIn: 'Dùng tại chỗ'
  },
  groupOrder: {
    title: 'Đặt hàng nhóm',
    namePlaceholder: 'Tên đơn hàng nhóm',
    from: 'Từ',
    deliverTo: 'Giao đến',
    pickupAt: 'Nhận tại',
    invitePeople: 'Mời người',
    chooseWhoPays: 'Chọn người thanh toán',
    paySubtitle: 'Người tổ chức (bạn) sẽ thanh toán toàn bộ đơn hàng nhóm. Phương thức thanh toán sẽ được nhập khi thanh toán.',
    youPayForEveryone: 'Bạn trả cho tất cả mọi người',
    hostWillPayForEveryone: 'Người tổ chức sẽ trả cho tất cả mọi người',
    limitPlaceholder: 'Nhập giới hạn mỗi người (tùy chọn)',
    perPerson: 'mỗi người',
    everyonePaysThemselves: 'Mỗi người tự trả',
    comingSoon: 'Sắp ra mắt',
    next: 'Tiếp theo',
    yourGroupOrderLink: 'Liên kết đặt hàng nhóm của bạn',
    copy: 'Sao chép',
    share: 'Chia sẻ',
    linkCopied: 'Đã sao chép liên kết!',
    join: 'Tham gia đơn hàng nhóm của {0}',
    spendingLimit: 'Giới hạn chi tiêu',
    limitNoLimit: 'Không giới hạn',
    limitOther: 'Khác',
    joinGroupOrder: 'Tham gia đặt hàng nhóm',
    joining: 'Đang tham gia...',
    loginToJoin: 'Đăng nhập để tham gia',
    continueAsGuest: 'Tiếp tục với tư cách khách',
    enterYourName: 'Nhập tên của bạn',
    joinOrderDisclaimer: 'Bằng cách nhấp vào THAM GIA Đơn hàng bạn đồng ý với',
    joinOrder: 'THAM GIA Đơn hàng',
    back: 'Quay lại',
    notSet: 'Chưa đặt',
    cancelGroupOrder: 'Hủy đặt hàng nhóm',
    cancelGroupOrderConfirmTitle: 'Hủy {0}?',
    cancelGroupOrderConfirmBody: 'Điều này sẽ kết thúc đặt hàng nhóm cho tất cả mọi người. Tất cả người tham gia sẽ bị xóa.',
    cancelGroupOrderConfirm: 'Có, hủy đi',
    cancelGroupOrderKeep: 'Giữ đặt hàng nhóm',
    cartMenuCancelGroup: 'Hủy đặt hàng nhóm',
    cartMenuLeaveGroup: 'Rời',
    cartMenuInvite: 'Mời người',
    lockedBannerGuest: 'Đơn hàng nhóm này đã bị khóa. Vui lòng liên hệ người tổ chức để thực hiện thay đổi.',
    lockedBannerHost: 'Giỏ hàng của bạn đã bị khóa. Bạn vẫn có thể tiến hành thanh toán.',
    unlockMyCart: 'Mở khóa giỏ hàng',
    othersInGroup: 'Người khác trong nhóm của bạn ({0} người)',
    othersHaveAdded: '{0} trong {1} người đã thêm sản phẩm',
    memberHostLabel: '(Người tổ chức)',
    memberReadyBadge: 'Sẵn sàng',
    memberWaitingBadge: 'Đang chờ',
    memberErrorBadge: 'Sản phẩm hết hàng',
    memberCartHasErrors: 'Một thành viên trong nhóm của bạn có sản phẩm hết hàng. Vui lòng xóa để tiếp tục.',
    memberNoItems: 'Chưa có sản phẩm',
    unlockMemberCart: 'Mở khóa giỏ hàng của {0}',
    removeMember: 'Xóa {0}',
    yourItems: 'Sản phẩm của bạn',
    leaveConfirmTitle: 'Rời đặt hàng nhóm này?',
    leaveConfirmBody: 'Sản phẩm của bạn sẽ bị xóa và người tổ chức sẽ được thông báo.',
    leaveConfirmBtn: 'Rời',
    leaveConfirmKeep: 'Hủy',
    removeConfirmTitle: 'Xóa {0} khỏi đặt hàng nhóm?',
    removeConfirmBody: 'Sản phẩm của {0} sẽ bị xóa và họ sẽ được thông báo.',
    removeConfirmBtn: 'Xóa {0}',
    checkoutConfirmTitle: 'Mọi người đã sẵn sàng chưa?',
    checkoutConfirmBody: 'Nếu bạn tiếp tục, đặt hàng nhóm sẽ bị khóa và không ai có thể thực hiện thay đổi.',
    unreadyConfirmTitleSingle: '{0} vẫn đang đặt món',
    unreadyConfirmTitleMulti: '{0} khách vẫn đang đặt món',
    unreadyConfirmBody: 'Thanh toán sẽ đóng đơn hàng cho tất cả mọi người.',
    unreadyConfirmWaitingOnPrefix: 'Đang chờ ',
    unreadyConfirmWaitingOnSuffix: '.',
    and: 'và',
    andOthers: 'và {0} người khác',
    checkoutWithCurrentBtn: 'Thanh toán với giỏ hàng của họ',
    checkoutWithCurrentSubtext: 'Đơn hàng bao gồm những gì họ đã thêm đến nay',
    removeCartsCheckoutBtn: 'Thanh toán không có họ',
    removeCartsCheckoutSubtext: 'Giỏ hàng và các mục của họ sẽ bị xóa khỏi đơn hàng',
    errorRemoveUnreadyCarts: 'Không thể xóa một số giỏ hàng. Vui lòng thử lại.',
    groupCartEmpty: 'Vui lòng thêm ít nhất một món trước khi thanh toán.',
    participantWaiting: 'Đang chờ...',
    notReadyCount: '{0} người tham gia chưa sẵn sàng',
    goToCheckout: 'Đến trang thanh toán',
    lockedInGroupOrder: 'Bạn đang trong đặt hàng nhóm — không thể thay đổi loại đơn hàng và thời gian.',
    checkoutProcessing: 'Đang xử lý...',
    checkoutBackBtn: 'Quay lại',
    readyBtn: 'Bạn đã sẵn sàng!',
    readyHint: 'Người tổ chức sẽ đặt hàng cho tất cả mọi người.',
    readyStatus: 'Bạn đã sẵn sàng!',
    imReadyBtn: 'Tôi đã sẵn sàng!',
    addItemsBtn: 'Thêm sản phẩm',
    lockedCheckoutBtn: 'Đơn hàng nhóm đã bị khóa',
    lockedTimeoutBtn: 'Đơn hàng bị khóa — hết thời gian',
    exceedsLimit: 'Vượt quá giới hạn đặt hàng nhóm',
    snackParticipantLeft: '{0} đã rời đặt hàng nhóm.',
    errorMarkReady: 'Không thể đánh dấu giỏ hàng là sẵn sàng. Vui lòng thử lại.',
    errorCartLocked: 'Người tổ chức đã khóa đơn hàng. Bạn không thể thực hiện thay đổi lúc này.',
    errorUnlockCart: 'Không thể mở khóa giỏ hàng. Vui lòng thử lại.',
    errorLockGroup: 'Không thể khóa đặt hàng nhóm. Vui lòng thử lại.',
    errorLeaveGroup: 'Không thể rời đặt hàng nhóm. Vui lòng thử lại.',
    errorCancelGroup: 'Không thể hủy đặt hàng nhóm. Vui lòng thử lại.',
    errorUnlockMember: 'Không thể mở khóa giỏ hàng. Vui lòng thử lại.',
    errorRemoveParticipant: 'Không thể xóa người tham gia. Vui lòng thử lại.',
    dialogRemovedTitle: 'Bạn đã bị xóa',
    dialogRemovedBody: 'Người tổ chức đã xóa bạn khỏi đặt hàng nhóm này. Sản phẩm của bạn đã được xóa.',
    dialogLeftTitle: 'Bạn đã rời {0}',
    dialogLeftBody: 'Sản phẩm của bạn đã được xóa.',
    dialogCancelledTitle: 'Đặt hàng nhóm đã bị hủy',
    dialogCancelledBody: 'Người tổ chức đã hủy đặt hàng nhóm này.',
    dialogPaidTitle: 'Đặt hàng thành công!',
    dialogPaidBody: 'Đặt hàng nhóm của bạn đã được đặt thành công.',
    dialogRecoveredTitle: 'Bạn có đặt hàng nhóm đang diễn ra',
    dialogRecoveredHost: 'Bạn là người tổ chức',
    dialogRecoveredGuest: 'Bạn là người tham gia',
    dialogRecoveredBtn: 'Tiếp tục',
    deadlineTitle: 'Đặt thời hạn',
    deadlineSubtitle: 'Mọi người nên đặt hàng trước khi nào?',
    deadlineDayLabel: 'Đặt hàng trước (Ngày)',
    deadlineTimeLabel: 'Đặt hàng trước (Giờ)',
    noDeadline: 'Không có thời hạn',
    noDeadlineSet: 'Chưa đặt thời hạn',
    deadlineSpecificTime: 'Thời gian cụ thể',
    orderDeadline: 'Thời hạn đặt hàng',
    orderBeforeDeadline: 'Đặt hàng trước {0}',
    peopleCanOrderAnytime: 'Mọi người có thể đặt hàng bất cứ lúc nào',
    notAvailableScheduled: 'Không có sẵn cho thời gian đã lên lịch này',
    deadlineNotAvailableNow: 'Thời hạn không khả dụng khi thời gian giao hàng được đặt là Ngay bây giờ.',
    noAvailableDeadlineTimes: 'Không có thời gian khả dụng cho thời hạn. Vui lòng chọn thời gian giao hàng muộn hơn.',
    noSpendingLimit: 'Không có giới hạn chi tiêu',
    spendingLimitValue: 'Giới hạn {0}',
    dialogChangedTitle: 'Đơn hàng được cập nhật bởi chủ nhóm',
    dialogChangedToDelivery: 'Đã chuyển sang Giao hàng',
    dialogChangedToPickup: 'Đã chuyển sang Lấy tại chỗ',
    dialogChangedTime: 'Thời gian đã thay đổi từ {0} thành {1}',
    dialogChangedTimeSet: 'Thời gian đặt lịch được đặt thành {0}',
    dialogChangedTimeCleared: 'Đã xóa thời gian đặt lịch (sớm nhất có thể)',
    timeChangedLabel: 'Đã thay đổi thời gian',
    timeChangedToLabel: 'Thời gian thay đổi thành',
    confirmChangeToDelivery: 'Chuyển sang Giao hàng?',
    confirmChangeToPickup: 'Chuyển sang Lấy tại chỗ?',
    confirmChangeTypeBody: 'Thao tác này sẽ cập nhật loại đơn hàng cho mọi người trong nhóm.',
    asap: 'Sớm nhất có thể',
    orderAsap: 'Đặt hàng sớm nhất có thể',
    now: 'Ngay bây giờ',
    staleTimeTitle: 'Thời gian bạn chọn không còn khả dụng',
    staleTimeNearestSlotLabel: 'Thời gian khả dụng gần nhất',
    staleTimeChooseAnother: 'Chọn thời gian khác',
    errorResetSchedule: 'Không thể cập nhật thời gian. Vui lòng thử lại.',
    errorUpdateSchedule: 'Không thể cập nhật thời gian. Vui lòng thử lại.',
    errorUpdateScheduleConflict: 'Không thể cập nhật vào lúc này. Vui lòng kiểm tra và thử lại.',
    discountsAtCheckout: 'Giảm giá được áp dụng khi thanh toán',
    deliveryFeeAtCheckout: 'Tính khi thanh toán',
    feesCalculatedAtCheckout: 'Thuế, phí và giảm giá được tính khi thanh toán',
    exceedsSpendingLimit: 'Mặt hàng này sẽ vượt quá hạn mức chi tiêu do chủ nhóm đặt.',
    cartFinalized: 'Đơn hàng nhóm của bạn đã được hoàn tất. Bạn không thể thêm mặt hàng nữa.',
    noDeadlineSlots: 'Không có khung giờ nào để đặt thời hạn.',
    errorUpdateDeadline: 'Không thể cập nhật thời hạn. Vui lòng thử lại.',
    deadlineUpdated: 'Thời hạn đặt hàng đã được cập nhật: {0}',
    deadlineRemoved: 'Thời hạn đặt hàng đã được cập nhật.',
    shareGroupOrder: 'Tham gia đơn hàng nhóm của tôi!',
    memberLocked: 'Đã khoá',
    snackParticipantLeftHost: '{0} đã rời đặt hàng nhóm.',
    tooltipBadgeNew: 'MỚI',
    tooltipTitle: 'Cách thức hoạt động của Đặt hàng nhóm',
    tooltipScene1Caption: 'Bắt đầu đặt hàng nhóm từ trang thực đơn',
    tooltipScene2Caption: 'Đặt thời hạn — và ai sẽ thanh toán',
    tooltipScene3Caption: 'Chia sẻ liên kết, hoặc để bạn bè quét mã để tham gia',
    tooltipScene4Caption: 'Mọi người thêm vào một giỏ hàng. Thanh toán một lần.',
    tooltipStartBtn: 'Bắt đầu Đặt hàng nhóm',
    tooltipGotItBtn: 'Đã hiểu',
    tooltipDemoPeopleJoined: '{0} người đã tham gia',
    tooltipDemoDeadlineTimeExample: 'Thứ 6, 10 Th7 · 12:30 CH',
    tooltipDemoPaySub: 'Bạn thanh toán · giới hạn $15 mỗi người',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'Giỏ hàng nhóm',
    tooltipDemoOneCheckout: 'Thanh toán một lần — bạn trả tiền',
    sheetTitle: 'Đặt hàng nhóm đã có mặt',
    sheetSubtitle: 'Đặt hàng cùng nhau — một giỏ hàng chung, một lần thanh toán.',
    sheetBullet1: 'Đặt thời hạn cho đơn hàng',
    sheetBullet2: 'Bạn thanh toán — hoặc đặt giới hạn chi tiêu',
    sheetBullet3: 'Mời bằng liên kết hoặc mã QR',
    sheetNotNowBtn: 'Để sau',
    showHowItWorks: 'Xem cách hoạt động',
    hostSetsTip: 'Với vai trò chủ nhóm, bạn đặt tiền tip cho toàn bộ đơn hàng nhóm.',
    checkoutErrorGeneric: 'Thanh toán không thành công. Vui lòng thử lại.',
    checkoutErrorInvalidCart: 'Một số món trong giỏ hàng cần được kiểm tra trước khi thanh toán.',
    checkoutErrorOutOfStock: 'Một số món không còn hàng. Vui lòng xóa và thử lại.',
    checkoutErrorMissingSelection: 'Vui lòng kiểm tra lựa chọn của một món trong giỏ hàng.',
    checkoutErrorInvalidItem: 'Một món trong giỏ hàng không còn hợp lệ. Vui lòng xóa và thử lại.',
    checkoutErrorPaymentDeclined: 'Thẻ của bạn đã bị từ chối. Vui lòng thử phương thức thanh toán khác.',
    checkoutErrorPaymentFraud: 'Phương thức thanh toán này đã bị ngân hàng phát hành từ chối. Vui lòng thử phương thức khác.',
    checkoutErrorCardDetails: 'Có vấn đề với thông tin thẻ. Vui lòng kiểm tra và thử lại.',
    checkoutErrorCardExpired: 'Thẻ này đã hết hạn. Vui lòng thử phương thức thanh toán khác.',
    checkoutErrorPaymentGateway: 'Không thể xử lý thanh toán. Vui lòng thử lại.',
    checkoutErrorNotOpen: 'Đơn hàng nhóm này không còn mở nữa.',
    checkoutErrorVersionConflict: 'Đơn hàng nhóm đã thay đổi trong khi bạn thanh toán. Vui lòng kiểm tra và thử lại.',
    checkoutErrorInProgress: 'Thanh toán đang được xử lý.',
    checkoutErrorEmpty: 'Giỏ hàng nhóm đang trống.',
    checkoutErrorBlocked: 'Một số thành viên vẫn chưa sẵn sàng.',
  },
  weChat: {
    warning: 'Vui lòng thoát trang và dùng trình quét QR của WeChat để quét mã',
    title: 'Nhập số bàn'
  },
  checkout: {
    addCoupon: 'Thêm mã giảm giá',
    couponCode: 'Mã giảm giá',
    title: 'Xác nhận đơn hàng',
    description: 'Bạn đã sẵn sàng gửi đơn hàng?',
    confirmCancel: 'Không',
    confirmApprove: 'Có',
    onlinePay: 'Thanh toán trực tuyến',
    weChatPay: 'Thanh toán WeChat',
    unitNumber: 'Tầng/Bộ (tuỳ chọn)',
    primaryMethod: 'Phương thức chính',
    secondaryMethod: 'Phương thức phụ',
    credits: 'Ví cửa hàng',
    orderHints: 'Ví dụ: hạn chế chế độ ăn uống, ghi chú đặc biệt',
    deliveryHints: 'Ví dụ: rung chuông khi giao, để gần cửa, số buzzer, vv.',
    deliveryOptions: 'Tùy chọn giao hàng',
    deliveryInstructions: 'Hướng dẫn giao hàng',
    orderDisposables: 'Dụng cụ sử dụng một lần, ống hút, vv.',
    deliveryDisposables: 'Dụng cụ sử dụng một lần khi giao',
    disposablesIncluded: 'Những món này **sẽ không** được bao gồm trừ khi bạn yêu cầu',
    noPaymentMethods: 'Không có tùy chọn thanh toán.<br>Vui lòng liên hệ {0}',
    billLoadError: 'Chúng tôi không thể tải tổng số tiền đơn hàng của bạn. Vui lòng thử lại.',
    applePayFailed: 'Không thể khởi động Apple Pay. Vui lòng thử lại hoặc chọn phương thức thanh toán khác.',
    retry: 'Thử lại',
    confirmDialog: {
      total: 'Tổng cộng',
      name: 'Tên cửa hàng',
      location: 'Địa điểm cửa hàng',
      deliveryInfo: 'Thông tin giao hàng',
      deliveryAddress: 'Địa chỉ giao hàng',
      deliveryPhone: 'Số điện thoại giao hàng',
      scheduled: 'Đã lên lịch cho',
      pay: 'Thanh toán',
      pickupTitle: 'Nhận hàng tại cửa hàng?',
      pickupBody: 'Xác nhận rằng bạn sẽ nhận đơn hàng này tại cửa hàng.',
      pickupTime: 'Thời gian nhận hàng:',
      beforeYouArrive: 'Trước khi bạn đến',
      yesPickUp: 'Có, tôi sẽ nhận hàng',
      goBack: 'Quay lại'
    },
    deliveryMessage: {
      leave_at_door: 'Để trước cửa',
      meet_at_door: 'Gặp nhân viên giao hàng tại cửa',
      meet_outside: 'Gặp bên ngoài'
    },
    couponTypes: {
      title: 'Mã giảm giá của bạn giới hạn các phương thức thanh toán:',
      membership: 'Ví thành viên',
      online: 'Thẻ tín dụng / Trực tuyến',
      wechat: 'WeChat',
      offline: 'Thanh toán tại cửa hàng'
    }
  },
  qr: {
    manulInput: 'Máy quét không hoạt động? Vui lòng nhập số bàn của bạn.',
    selectTable: 'Số bàn của bạn',
    select: 'Xác nhận'
  },
  apps: {
    giftcard: 'Thẻ Quà Tặng',
    coupons: 'Mua mã giảm giá',
    deposit: 'Nạp Tiền',
    lineup: 'Danh Sách Chờ',
    reservation: 'Đặt Bàn'
  },
  requestService: {
    openButton: 'Yêu cầu phục vụ',
    title: 'Gửi yêu cầu tới nhân viên của bạn',
    sent: 'Yêu cầu đã được gửi',
    login: 'Cần đăng nhập để sử dụng chức năng này',
    tableNeeded: 'Vui lòng đặt số bàn để sử dụng chức năng này'
  },
  sharedCart: {
    bannerLabel: 'Bàn chung · Bàn #{0}',
    live: 'Trực tiếp',
    staleItemWarning: 'Đã được cập nhật bởi khách khác — kiểm tra trước khi lưu',
    sentToKitchen: 'Đã gửi đến bếp',
    roundSentToKitchen: 'Lượt {0} · Đã gửi đến bếp',
    alreadyOrdered: 'Đã gọi',
    itemCount: '{0} món',
    stillOrdering: 'Đang thêm món',
    sending: 'Đang gửi...',
    reconnected: 'Đã kết nối lại với bàn chung {0}.',
    joinedTitle: 'Bạn đã tham gia bàn!',
    joinedBody: 'Bây giờ bạn đang chia sẻ đơn hàng của bàn này với mọi người ở đây.',
    completedTitle: 'Đơn hàng bàn đã được thanh toán!',
    completedBody: 'Thanh toán cho bàn này đã hoàn tất. Cảm ơn!',
    billAtPosTitle: 'Hóa đơn đã được gửi đến quầy thu ngân',
    billAtPosBody: 'Hóa đơn của bàn bạn đã được gửi đến quầy. Vui lòng thanh toán tại đó để hoàn tất đơn hàng.',
    cancelledTitle: 'Phiên bàn đã kết thúc',
    cancelledBody: 'Phiên giỏ hàng chung của bàn này đã hết hạn. Vui lòng quét mã QR để bắt đầu phiên mới.',
    roundFired: 'Các món đã được gửi đến bếp.',
    errorFireRound: 'Gửi đến bếp thất bại. Vui lòng thử lại.',
    errorItemChanged: 'Người khác đã thay đổi món này — đã cập nhật phiên bản mới nhất, vui lòng thử lại.',
    errorMutateCart: 'Thao tác không thành công. Vui lòng thử lại.',
    errorSessionClosed: 'Bàn này đã được đóng.',
    sharedTable: 'Bàn Chung',
    sharedTableActive: '● Bàn Chung Đang Hoạt Động',
    tableLabel: 'Bàn {0}',
    errorStartSharedTable: 'Không thể bắt đầu bàn chung. Vui lòng thử lại.',
  },
}
